import { appURLs } from "@/app/constants.mjs";
import StaticTFT from "@/game-tft/static.mjs";

const standardSet = "set1";

export default function getChampionCenteredImage(
  key,
  set,
  smallVersion = false,
) {
  const useSet = set ?? standardSet;
  if (useSet === "set1") {
    key = StaticTFT.getChampName(key);
  }

  const smallSuffix = smallVersion ? "_small" : "";

  return `${appURLs.CDN}/blitz/centered-tft/${useSet}/${key}${smallSuffix}.webp`;
}
